export const KEY_VALUES = {
  Enter: "Enter",
  Space: "Space",
  Delete: "Delete",
  Backspace: "Backspace",
  ArrowLeft: "ArrowLeft",
  ArrowRight: "ArrowRight",
  ArrowUp: "ArrowUp",
  ArrowDown: "ArrowDown",
} as const;

export const KEY_CODES = {
  KeyZ: "KeyZ",
} as const;
